module.exports = __webpack_public_path__ + "img/banner.77d65747.png";